// extracted by mini-css-extract-plugin
module.exports = {"content":"ContentContainer_content__37Tax","contentTitle":"ContentContainer_contentTitle__2cINn","body":"ContentContainer_body__2bxuS"};